// src/js/components/voluntariado-modal.js

document.addEventListener('DOMContentLoaded', () => {
  const modal          = document.getElementById('voluntariado-modal');
  if (!modal) return;

  const modalContent   = modal.querySelector('.js-vol-modal-content');
  const formPanel      = document.getElementById('vol-modal-form-panel');
  const successPanel   = document.getElementById('vol-modal-success-panel');
  const errorPanel     = document.getElementById('vol-modal-error-panel');
  const errorMsg       = document.getElementById('vol-error-msg');
  const errorText      = document.getElementById('vol-send-error-text');
  const form           = document.getElementById('voluntariado-form');
  const submitBtn      = document.getElementById('vol-submit-btn');
  const btnText        = document.getElementById('vol-btn-text');
  const btnIcon        = document.getElementById('vol-btn-icon');
  const btnSpinner     = document.getElementById('vol-btn-spinner');
  const retryBtn       = document.getElementById('vol-retry-btn');

  // ── Abrir / Cerrar modal ──────────────────────────────────────────

  const openModal = () => {
    // Aseguramos el estado de inicio
    [formPanel, errorMsg].forEach(el => el && el.classList.remove('hidden'));
    [successPanel, errorPanel].forEach(el => el && el.classList.add('hidden'));
    if (form) form.reset();
    resetExpDetalle();

    modal.classList.remove('opacity-0', 'pointer-events-none');
    modalContent.classList.remove('scale-95');
    modalContent.classList.add('scale-100');
    document.body.style.overflow = 'hidden';

    // Scroll al inicio del modal
    modal.scrollTop = 0;

    // Ocultar error de validación al abrir
    if (errorMsg) errorMsg.classList.add('hidden');
  };

  const closeModal = () => {
    modal.classList.add('opacity-0', 'pointer-events-none');
    modalContent.classList.remove('scale-100');
    modalContent.classList.add('scale-95');
    document.body.style.overflow = '';
  };

  // ── Trigger: botón "HAZTE VOLUNTARIO" ────────────────────────────

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-vol-modal-trigger');
    if (trigger) {
      e.preventDefault();
      openModal();
    }
  });

  // ── Botones de cierre ─────────────────────────────────────────────

  modal.querySelectorAll('.js-vol-modal-close').forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  // Delegación para el botón de cierre del panel de éxito
  // (se añade al panel para capturar el botón dinámico)
  if (successPanel) {
    successPanel.addEventListener('click', (e) => {
      if (e.target.closest('.js-vol-modal-close')) closeModal();
    });
  }

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('pointer-events-none')) {
      closeModal();
    }
  });

  // ── Campo experiencia condicional ─────────────────────────────────

  const expSi  = document.getElementById('exp-si');
  const expNo  = document.getElementById('exp-no');
  const expDet = document.getElementById('vol-exp-detalle');

  function resetExpDetalle() {
    if (expDet) expDet.classList.add('hidden');
  }

  [expSi, expNo].forEach(radio => {
    if (!radio) return;
    radio.addEventListener('change', () => {
      if (!expDet) return;
      expDet.classList.toggle('hidden', !expSi.checked);
    });
  });

  // ── Reintentar ────────────────────────────────────────────────────

  if (retryBtn) {
    retryBtn.addEventListener('click', () => {
      errorPanel.classList.add('hidden');
      formPanel.classList.remove('hidden');
      setLoading(false);
    });
  }

  // ── Helpers ───────────────────────────────────────────────────────

  function setLoading(loading) {
    if (!submitBtn) return;
    submitBtn.disabled = loading;
    if (btnText)    btnText.textContent = loading ? 'Enviando...' : 'Enviar solicitud';
    if (btnIcon)    btnIcon.classList.toggle('hidden', loading);
    if (btnSpinner) btnSpinner.classList.toggle('hidden', !loading);
  }

  function collectData() {
    if (!form) return {};
    const fd = new FormData(form);
    const multiFields = ['disponibilidad', 'areas', 'preferencia_contacto'];
    const data = {};

    for (const [key, value] of fd.entries()) {
      if (multiFields.includes(key)) {
        if (!data[key]) data[key] = [];
        data[key].push(value);
      } else {
        data[key] = value;
      }
    }

    // Sustituir "Otras" por el texto libre si está marcado
    const otrasCheck = document.getElementById('areas-otras-check');
    const otrasTexto = document.getElementById('areas-otras-texto');
    if (otrasCheck && otrasCheck.checked && otrasTexto && otrasTexto.value.trim()) {
      if (!data['areas']) data['areas'] = [];
      const idx = data['areas'].indexOf('Otras');
      if (idx !== -1) data['areas'][idx] = `Otras: ${otrasTexto.value.trim()}`;
    }

    return data;
  }

  function validate() {
    let valid = true;

    // Campos de texto / fecha obligatorios
    ['nombre', 'fecha_nacimiento', 'dni', 'ciudad', 'telefono', 'email'].forEach(name => {
      const el = form.querySelector(`[name="${name}"]`);
      if (el && !el.value.trim()) valid = false;
    });

    // Email con @
    const emailEl = form.querySelector('[name="email"]');
    if (emailEl && emailEl.value && !emailEl.value.includes('@')) valid = false;

    // Radio groups obligatorios
    ['horas_semanales', 'duracion', 'experiencia_previa', 'certificado_delitos'].forEach(name => {
      const checked = [...form.querySelectorAll(`[name="${name}"]`)].some(r => r.checked);
      if (!checked) valid = false;
    });

    // Checkboxes de autorización
    const priv = document.getElementById('vol-privacidad');
    const conf = document.getElementById('vol-confirmacion');
    if (priv && !priv.checked) valid = false;
    if (conf && !conf.checked) valid = false;

    return valid;
  }

  // ── Envío ─────────────────────────────────────────────────────────

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (errorMsg) errorMsg.classList.add('hidden');

      if (!validate()) {
        if (errorMsg) {
          errorMsg.classList.remove('hidden');
          errorMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      const data = collectData();

      // reCAPTCHA v3
      if (typeof grecaptcha !== 'undefined') {
        const siteKey = process.env.PARCEL_PUBLIC_RECAPTCHA_SITE_KEY || '6Ld_placeholder_site_key_fam';
        data.recaptchaToken = await grecaptcha.execute(siteKey, { action: 'voluntariado' });
      }

      setLoading(true);

      try {
        const response = await fetch('/.netlify/functions/send-voluntariado', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.message || `Error ${response.status}`);
        }

        // Éxito
        setLoading(false);
        formPanel.classList.add('hidden');
        successPanel.classList.remove('hidden');
        modal.scrollTop = 0;

      } catch (err) {
        console.error('Error al enviar formulario de voluntariado:', err);
        setLoading(false);

        if (errorText) errorText.textContent = err.message || 'Error inesperado. Por favor, inténtalo de nuevo.';
        formPanel.classList.add('hidden');
        errorPanel.classList.remove('hidden');
        modal.scrollTop = 0;
      }
    });
  }
});

